import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BuyCreditsPage } from '../buy-credits/buy-credits';

/**
 * Generated class for the CadFornecedorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cad-fornecedor',
  templateUrl: 'cad-fornecedor.html',
})
export class CadFornecedorPage {
public myVariable:string;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CadFornecedorPage');
  }
  goToBuyCredits(){
    this.navCtrl.push(BuyCreditsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/cad-fornecedor/cad-fornecedor.ts